import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {IonInput, ModalController, NavController, NavParams, Platform} from '@ionic/angular';
import {select, Store} from '@ngrx/store';
import {getAktuelleVeranstaltung} from '../app-state/app-state.reducer';
import {DatenState} from '../app-state/daten.reducer';
import {Veranstaltung} from '../../../clients/veranstaltungen';
import {Abteilung, IncidentDetail, IncidentManagementBenutzerZugriff, IncidentsAnzeigeMandantOptions, Rolle} from '../../../clients/incidents';
import {UuidService} from '@orga-app/providers/uuid.service';
import {getIncidentsMandantOptions} from '@orga-app/mandant/reducer';
import {Observable, Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {getAbteilungSelected, getDelegationRollen, getIncidentDetail, getIncidentDetailOriginal, getVeranstaltungen} from './incident.selectors';
import {IncidentSpeichernAction, LadeAktuelleVeranstaltungenAction, SetzeAktuelleVorlage, SetzeIncidentAbteilungAction, SetzeIncidentBeschreibungAction, SetzeIncidentDelegationRolleAction, SetzeIncidentDetailIdAction, SetzeIncidentOrtAction, SetzeIncidentTitelAction, SetzeIncidentZentraleAction, SetzeVeranstaltungsIdAction} from './incident.actions.ui';
import {NotificationService} from '@orga-app/providers/notification.service';
import {getZugriffIncidents} from '../../navi/navi.reducer';
import {VorlageAuswaehlenPage} from './vorlage-auswaehlen/vorlage-auswaehlen.page';

/**
 * Generated class for the AufgabePage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
    selector: 'app-incident',
    templateUrl: './incident.page.html',
    styleUrls: ['./incident.page.scss'],
})
export class IncidentPage implements OnInit, OnDestroy {
    @Input() incidentId: string;
    @ViewChild('titelInput', {static: false}) titelInput: IonInput;

    public aktuelleVeranstaltung$: Observable<Veranstaltung>;
    public mandantOptions$: Observable<IncidentsAnzeigeMandantOptions>;

    incidentDetail$: Observable<IncidentDetail>;
    incidentDetailOriginal$: Observable<IncidentDetail>;

    veranstaltungen$: Observable<Array<Veranstaltung>>;

    abteilungSelected$: Observable<Abteilung>;
    delegationRollen$: Observable<Array<Rolle>>;

    zentraleLeitstelleTitel: string;

    zugriff$: Observable<IncidentManagementBenutzerZugriff>;


    private unsubscribe$ = new Subject();
    private aiName = 'IncidentPage';

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                private appStore: Store<DatenState>,
                public platform: Platform,
                private modalCtrl: ModalController,
                private route: ActivatedRoute,
                private store: Store<DatenState>,
                public router: Router,
                private uuid: UuidService,
                private notificationService: NotificationService) {
        this.aktuelleVeranstaltung$ = this.appStore.pipe(select(getAktuelleVeranstaltung));
        this.mandantOptions$ = this.appStore.pipe(select(getIncidentsMandantOptions));

        this.mandantOptions$.subscribe(x => this.zentraleLeitstelleTitel = x.zentrale_text).unsubscribe();

        this.incidentDetail$ = this.store.pipe(select(getIncidentDetail));
        this.incidentDetailOriginal$ = this.store.pipe(select(getIncidentDetailOriginal));

        this.veranstaltungen$ = this.store.pipe(select(getVeranstaltungen));

        this.abteilungSelected$ = this.store.pipe(select(getAbteilungSelected));
        this.delegationRollen$ = this.store.pipe(select(getDelegationRollen));

        this.zugriff$ = this.store.pipe(select(getZugriffIncidents));
    }


    ngOnInit() {
        setTimeout(() => {
            if (this.titelInput !== null && this.titelInput !== undefined) {
                this.titelInput.setFocus();
            }
        }, 500);
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }

    ionViewWillEnter() {
        this.viewWillEnterPage().then();
    }

    async viewWillEnterPage() {
        this.store.dispatch(new LadeAktuelleVeranstaltungenAction());

        // console.log('IncidentId: ', this.incidentId);
        if (this.incidentId !== undefined && this.incidentId !== null) {
            this.store.dispatch(new SetzeIncidentDetailIdAction(this.incidentId));
        } else {
            this.store.dispatch(new SetzeIncidentDetailIdAction(''));
            this.aktuelleVeranstaltung$.subscribe(x => {
                if (x !== null && x !== undefined) {
                    this.store.dispatch(new SetzeVeranstaltungsIdAction(x.veranstaltung_id));
                }
            }).unsubscribe();
        }
    }

    ok() {
        this.store.dispatch(new IncidentSpeichernAction());
        this.store.dispatch(new SetzeIncidentDetailIdAction(''));

        if (this.incidentId === undefined || this.incidentId === '') {

            this.modalCtrl.dismiss({
                result: true,
                message: 'Der Incident wurde an die ' + this.zentraleLeitstelleTitel + ' oder an die ausgewählte Abteilung übergeben.'
            });
        } else {
                // Incident Bearbeiten
                this.modalCtrl.dismiss({
                    result: true,
                    message: 'Der Incident wurde gespeichert.'
                });
        }
    }

    abbrechen() {
        this.modalCtrl.dismiss();
    }

    select($event) {
        if ($event != null && $event.target != null && typeof $event.target.select === 'function') {
            $event.target.select();
        }
    }

    back() {
        this.store.dispatch(new SetzeIncidentDetailIdAction(''));
    }

    setzeVerantwortungAbteilung(abteilung: Abteilung) {
        // console.log('Abteilung: ', abteilung);
        this.store.dispatch(new SetzeIncidentAbteilungAction(abteilung));
    }

    setzeVerantwortungZentral() {
        this.store.dispatch(new SetzeIncidentZentraleAction());
    }

    setzeDelegationRolle(rolle: Rolle) {
        this.store.dispatch(new SetzeIncidentDelegationRolleAction(rolle));
    }

    setzeBeschreibung($event: CustomEvent) {
        // console.log('SetzeBeschreibung: ', $event);
        this.store.dispatch(new SetzeIncidentBeschreibungAction($event.detail.target.value));
    }

    setzeTitel($event: CustomEvent) {
        // console.log('SetzeTitel: ', $event);
        this.store.dispatch(new SetzeIncidentTitelAction($event.detail.target.value));
    }

    setzeOrt($event: CustomEvent) {
        // console.log('SetzeOrt: ', $event);
        this.store.dispatch(new SetzeIncidentOrtAction($event.detail.target.value));
    }

    changeVeranstaltung($event: CustomEvent) {
        if ($event.detail.value) {
            this.store.dispatch(new SetzeVeranstaltungsIdAction($event.detail.value));
        }
    }

    async selectVorlage() {
        const imageModal = await this.modalCtrl.create({
            component: VorlageAuswaehlenPage, componentProps: {
            }
        });
        imageModal.onDidDismiss().then(data => {
            if (data !== undefined && data.data !== undefined && data.data.selectedVorlage !== undefined && data.data.selectedVorlage !== null) {
                let zugriff: IncidentManagementBenutzerZugriff = null;
                const vorlage: IncidentDetail = {
                    titel: data.data.selectedVorlage.titel,
                    beschreibung: data.data.selectedVorlage.beschreibung,
                    mandant_id: data.data.selectedVorlage.mandant_id,
                    ist_verantwortlichkeit_zentrale: data.data.selectedVorlage.ist_verantwortlichkeit_zentrale,
                    ist_verantwortlichkeit_abteilung: data.data.selectedVorlage.ist_verantwortlichkeit_abteilung,
                    verantwortlichkeit_funktionsbereich_id: data.data.selectedVorlage.verantwortlichkeit_funktionsbereich_id,
                    delegation_funktionsbereich_id: data.data.selectedVorlage.delegation_funktionsbereich_id,
                    delegation_rolle_id: data.data.selectedVorlage.delegation_rolle_id,
                    veranstaltung_id: '',
                    incident_id: '',
                    ort: ''
                };
                let abteilung: Abteilung = null;

                this.zugriff$.subscribe(x => {
                    zugriff = x;
                }).unsubscribe();

                if (zugriff !== undefined && zugriff !== null && (vorlage.ist_verantwortlichkeit_abteilung || vorlage.ist_verantwortlichkeit_zentrale)) {
                    if (!zugriff.anlegen.darf_verantwortung_bei_anlegen) {
                        if (vorlage.ist_verantwortlichkeit_abteilung || vorlage.ist_verantwortlichkeit_zentrale) {
                            // Meldung rausgeben, dass vorgegebene Verantwortung nicht gesetzt werden kann
                            this.notificationService.showMessageWithOk('Die in der Vorlage festgelegte Verantwortung (Zentrale) (und ggf. Delegation) kann von Ihnen nicht zugewiesen werden. Sie haben keine Berechtigung, um diese Zuweisungen zu übernehmen.');
                        }
                        vorlage.ist_verantwortlichkeit_zentrale = false;
                        vorlage.ist_verantwortlichkeit_abteilung = false;
                        vorlage.verantwortlichkeit_funktionsbereich_id = null;
                        vorlage.delegation_rolle_id = null;
                        vorlage.delegation_funktionsbereich_id = null;
                    } else {
                        let index = -1;
                        if (zugriff.anlegen.abteilungen !== null) {
                            index = zugriff.anlegen.abteilungen.findIndex(x => x.funktionsbereich_id === vorlage.verantwortlichkeit_funktionsbereich_id);
                        }

                        if (vorlage.ist_verantwortlichkeit_abteilung) {
                            abteilung = zugriff.anlegen.abteilungen[index];
                            this.store.dispatch(new SetzeIncidentAbteilungAction(abteilung));
                        }

                        if (vorlage.ist_verantwortlichkeit_abteilung && index === -1) {
                            // Meldung rausgeben, dass vorgegebene Verantwortung nicht gesetzt werden kann
                            this.notificationService.showMessageWithOk('Die in der Vorlage festgelegte Verantwortung (und ggf. Delegation) kann von Ihnen nicht zugewiesen werden. Sie haben keine Berechtigung, um diese Zuweisungen zu übernehmen.');

                            vorlage.ist_verantwortlichkeit_abteilung = false;
                            vorlage.verantwortlichkeit_funktionsbereich_id = null;
                            vorlage.delegation_rolle_id = null;
                            vorlage.delegation_funktionsbereich_id = null;
                        } else {
                            let delegationRollen: Array<Rolle> = [];
                            this.delegationRollen$.subscribe(x => {
                                delegationRollen = x;
                            }).unsubscribe();

                            const indexDelegation = delegationRollen.findIndex(x => x.rolle_id === vorlage.delegation_rolle_id);

                            if (!zugriff.anlegen.darf_delegation_bei_anlegen) {
                                if (indexDelegation === -1) {
                                    this.notificationService.showMessageWithOk('Die in der Vorlage festgelegte Delegation kann von Ihnen nicht zugewiesen werden. Sie haben keine Berechtigung.');
                                    vorlage.delegation_rolle_id = null;
                                    vorlage.delegation_funktionsbereich_id = null;
                                }

                                vorlage.delegation_rolle_id = null;
                                vorlage.delegation_funktionsbereich_id = null;
                            } else {

                                if (vorlage.delegation_rolle_id !== null && vorlage.delegation_rolle_id !== undefined) {
                                    if (indexDelegation === -1) {
                                        this.notificationService.showMessageWithOk('Die in der Vorlage festgelegte Delegation kann von Ihnen nicht zugewiesen werden. Sie haben keine Berechtigung.');
                                        vorlage.delegation_rolle_id = null;
                                        vorlage.delegation_funktionsbereich_id = null;
                                    }
                                }
                            }
                        }
                    }
                }

                this.store.dispatch(new SetzeAktuelleVorlage(vorlage));
            }
        });
        await imageModal.present();
    }
}
